import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RoleFilters } from '../models/roleFilters';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  public filterRoles = new RoleFilters({});
  public roleFiltersSubject = new BehaviorSubject(this.filterRoles);

  constructor() {
    if(this.getLocalRoleFilters()) {
      this.filterRoles=this.getLocalRoleFilters();
      this.roleFiltersSubject.next(this.filterRoles);
    }
  }

  public updateFilterValues(
    property:string,
    value:boolean
  ) {
    this.filterRoles[property]=value;
    this.roleFiltersSubject.next(this.filterRoles);
    this.setLocalRoleFilters(this.filterRoles);
  }

  public setLocalRoleFilters(roleFilters:RoleFilters){
    localStorage.setItem('roleFilters',JSON.stringify(roleFilters));
  }

  public getLocalRoleFilters(){
      return JSON.parse(localStorage.getItem('roleFilters'));
  }
}
